<gs-generic-crud *ngIf="configuration" [configuration]="configuration" />
